import { render } from "./AppIconButton.vue?vue&type=template&id=1787543e&scoped=true"
import script from "./AppIconButton.vue?vue&type=script&lang=js"
export * from "./AppIconButton.vue?vue&type=script&lang=js"

import "./AppIconButton.vue?vue&type=style&index=0&id=1787543e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1787543e"]])

export default __exports__